import(/* webpackMode: "eager" */ "/app/hub/src/app/[accountId]/folder/[folderId]/entry/[entryId]/error.tsx");
